import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();
const DESIGN_VERSION = 'hunar-v1';

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const savedDesignVersion = localStorage.getItem('hunar-design-version');
    if (savedTheme && ['refero-v1', DESIGN_VERSION].includes(savedDesignVersion)) {
      setTheme(savedTheme);
      localStorage.setItem('hunar-design-version', DESIGN_VERSION);
      document.body.classList.remove('light', 'dark');
      document.body.classList.add(savedTheme);
    } else {
      setTheme('dark');
      localStorage.setItem('theme', 'dark');
      localStorage.setItem('hunar-design-version', DESIGN_VERSION);
      document.body.classList.remove('light', 'dark');
      document.body.classList.add('dark');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    localStorage.setItem('hunar-design-version', DESIGN_VERSION);
    document.body.classList.remove('light', 'dark');
    document.body.classList.add(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
